import PropTypes from 'prop-types'
import { ProgresSpinner } from '../../antd/common/ProgresSpinner'
import { Empty, Flex, Typography } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import RecordsCount from './RecordsCount'

const NoRecordsFound = ({ loading = false, caption }) => {
  const intl = useIntl()
  const defaultCaption = intl.formatMessage({ id: 'processes.loading' })
  return (
    <>
      <Flex
        align="center"
        justify="center"
        gap={16}
        className="full-width"
        style={{ height: 'calc(100vh - 380px)' }}
      >
        {loading ? (
          <ProgresSpinner
            caption={caption || defaultCaption}
            className="no-records"
          />
        ) : (
          <Empty description={ <RecordsCount count={0} /> } />
        )}
      </Flex>
    </>
  )
}

NoRecordsFound.propTypes = {
  loading: PropTypes.bool,
  caption: PropTypes.string,
}

export default NoRecordsFound
